import { useSelector } from "react-redux";
import useEcommerceOrderActions from "./_actions";

export const useEcommerceOrder = () => {
  const {
    fetchEcommerceOrderList,
    getEcommerceOrderDetail,
    updateEcommerceOrder,
    confirmEcommerceOrder,
    cancelEcommerceOrder,
    submitEcommerceOrder,
    readyToDeliverEcommerceOrder,
    deliveringEcommerceOrder,
    completeEcommerceOrder,
    changedOrderedDate,

    getNewOrderCount,
    
    changeSearchTerm,
    changeStartDate,
    changeEndDate,
    changeRegionCodeFilter,
    changeTownshipCodeFilter,
    changeVillageTractCodeFilter,
    changeVillageCodeFilter,
    changeSettlementFilter,
    changeRowsPerPage,
    changeCurrentPage,
    changeStatusFilter,
    changePaymentFilter,
    refreshDialogState
  } = useEcommerceOrderActions();

  const ecommerceOrder = useSelector((state) => state.ecommerceOrder.data);
  const currentPage = useSelector((state) => state.ecommerceOrder.currentPage);
  const totalRows = useSelector((state) => state.ecommerceOrder.totalRows);
  const rowsPerPage = useSelector((state) => state.ecommerceOrder.rowsPerPage);
  const searchTerm = useSelector((state) => state.ecommerceOrder.searchTerm);
  const startDate = useSelector((state) => state.ecommerceOrder.filters?.startDate);
  const endDate = useSelector((state) => state.ecommerceOrder.filters?.endDate);
  const region_id = useSelector((state) => state.ecommerceOrder.filters?.region_id);
  const township_id = useSelector(state => state.ecommerceOrder.filters.township_id);
  const village_tract_id = useSelector(state => state.ecommerceOrder.filters.village_tract_id);
  const village_id = useSelector(state => state.ecommerceOrder.filters.village_id);
  const settlement_id = useSelector(state => state.ecommerceOrder.filters.settlement_id);
  
  const isError = useSelector((state) => state.ecommerceOrder.isError);
  const isLoading = useSelector((state) => state.ecommerceOrder.isLoading);
  const errorMessage = useSelector((state) => state.ecommerceOrder.errorMessage);
  const apiAction = useSelector(state => state.ecommerceOrder.action);

  const statusFilter = useSelector(state => state.ecommerceOrder.filters.status);
  const paymentFilter = useSelector(state => state.ecommerceOrder.filters.payment);

  const newOrderCount = useSelector(state => state.ecommerceOrder.newOrder);

  return {
    // state
    ecommerceOrder,
    currentPage,
    totalRows,
    rowsPerPage,
    searchTerm,
    startDate,
    endDate,
    region_id,
    township_id,
    village_tract_id,
    village_id,
    settlement_id,
    isError,
    isLoading,
    apiAction,
    errorMessage,
    statusFilter,
    paymentFilter,

    newOrderCount,

    // actions
    fetchEcommerceOrderList,
    getEcommerceOrderDetail,
    updateEcommerceOrder,
    confirmEcommerceOrder,
    cancelEcommerceOrder,
    submitEcommerceOrder,
    readyToDeliverEcommerceOrder,
    deliveringEcommerceOrder,
    completeEcommerceOrder,
    changedOrderedDate,

    getNewOrderCount,

    changeSearchTerm,
    changeStartDate,
    changeEndDate,
    changeRegionCodeFilter,
    changeTownshipCodeFilter,
    changeVillageTractCodeFilter,
    changeVillageCodeFilter,
    changeSettlementFilter,
    changeCurrentPage,
    changeRowsPerPage,
    changeStatusFilter,
    changePaymentFilter,
    refreshDialogState
  };
};

export { default as ecommerceOrderReducer } from "./_reducers";